export default __webpack_public_path__ + "images/map.c05cf618284197544825013b7ef00177.png";